import { createContext, useContext, useEffect, useState } from "react";
import qs from "qs";
import { useLocation } from "react-router";
import { useAlerts } from "common";
import { getLastUploadedInfo } from "app/services/expensesService";

export const ExpensesContext = createContext();

export const ExpensesProvider = ({ children }) => {
  // Getting location object from useLocation (react-router)
  const location = useLocation();

  // State variable to store last uploaded info to display and set as default filters
  const [lastUploadedInfo, setLastUploadedInfo] = useState("");

  // State for filters
  const params = qs.parse(location.search, { ignoreQueryPrefix: true });
  const [expensesFilters, setExpensesFilters] = useState({
    fiscalYear: params.fiscalYear || "",
    glPeriod: params.glPeriod || "",
    posted: params.posted || "",
    conditionType: params.conditionType || "",
    notification: params.notification || "",
  });

  // State for Sort
  const [sort, setSort] = useState({
    column: "validateStatus",
    orderBy: "asc",
  });

  // State for pagination
  const [pagination, setPagination] = useState({
    page: 0,
    rowsPerPage: 10,
  });

  const [initialLoad, setInitialLoad] = useState(true);
  const { clearAlert, setAlert } = useAlerts();

  useEffect(() => {
    if (location.pathname.split("/")[1] !== "expenses") {
      setExpensesFilters({
        fiscalYear: lastUploadedInfo.lastUploadFiscalYear,
        glPeriod: lastUploadedInfo.lastUploadGLPeriod,
        posted: "",
        conditionType: "",
        notification: "",
      });
      setSort({
        column: "validateStatus",
        orderBy: "asc",
      });
      setPagination({
        page: 0,
        rowsPerPage: 10,
      });
    }
  }, [location.pathname, lastUploadedInfo]);

  useEffect(() => {
    if (location.pathname.split("/")[1] === "expenses") {
      getLastUploadedInfo(
        setLastUploadedInfo,
        setExpensesFilters,
        setInitialLoad,
        clearAlert,
        setAlert,
      );
    }
    // eslint-disable-next-line
  }, [location.pathname]);

  return (
    <ExpensesContext.Provider
      value={{
        expensesFilters,
        setExpensesFilters,
        sort,
        setSort,
        pagination,
        setPagination,
        lastUploadedInfo,
        setLastUploadedInfo,
        initialLoad,
      }}
    >
      {children}
    </ExpensesContext.Provider>
  );
};

export const useExpensesContext = () => {
  return useContext(ExpensesContext);
};
